import { render, staticRenderFns } from "./StudentInsurance.vue?vue&type=template&id=29d86798"
import script from "./StudentInsurance.vue?vue&type=script&lang=js"
export * from "./StudentInsurance.vue?vue&type=script&lang=js"
import style0 from "./StudentInsurance.vue?vue&type=style&index=0&id=29d86798&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports